<template>
  <div class="message-layout">
    <div class="header DDheaderN">
     <div class="zWfDK">
		 <button class="gCXVCl iylSZi" @click="drawer = !drawer">
			<i class="el-icon-menu iOnyRd"></i>
		 </button>
		 <a href="/">
			 <i class="DDlogo"></i>
		 </a>
	 </div>
	 <el-popover
		placement="bottom"
		width="300"
		popper-class="userIconPopper"
		:visible-arrow="false"
		trigger="hover">
		<div class="userIconPopperNav">
			<div class="box-card">
				<div class="userIconPopperTopNav">
					<div slot="header" class="clearfix">
						<div class="userIconNav " slot="reference"><el-avatar :size="36" :src="$store.state.userIcon"></el-avatar></div>
						<span>{{ $store.state.username }}</span>
					</div>
					<div>
						<ul class="userIconPopperTopUl">
							<li class="li-first">
								<a href="/basic_info">基本资料</a>
							</li>
							<li>
								<a href="/authc">实名认证</a>
							</li>
							<li>
								<a href="/secure">安全设置</a>
							</li>
						</ul>
					</div>
				</div>
			<div class="userIconPopperMediumNav">
				<el-menu
					  :router="true"
				      class="">
				      <el-menu-item index="http://gr.ddzzii.com">
				        <i class="el-icon-menu"></i>
				        <span slot="title">共享工人</span>
				      </el-menu-item>
				      <el-menu-item index="/2">
				        <i class="el-icon-menu"></i>
				        <span slot="title">共享仓储</span>
				      </el-menu-item>
				      <el-menu-item index="http://gr.ddzzii.com">
				        <i class="el-icon-menu"></i>
				        <span slot="title">揭榜挂帅</span>
				      </el-menu-item>
				    </el-menu>
			</div>
			<div class="userIconPopperBottonNav">
				<div>
					<a class="lkfbkL" @click="logout()">退出登录</a>
				</div>
			</div>
			</div>
		</div>
		<div class="userIconNav" slot="reference">
			<el-avatar :size="36" :src="$store.state.userIcon" style="float: left;"></el-avatar>
			<div style="float: left; line-height: 36px; margin:0 20px;">{{$store.state.username}}</div>
		</div>
	 </el-popover>
    </div>
    <div class="root">
	  <el-drawer
	    title="产品与服务"
	    :visible.sync="drawer"
	  	size="20%"
	  	:show-close="false"
		:modal="true"
	  	:modal-append-to-body="false"
	  	custom-class="custom-class"
	    :direction="direction">
		<el-menu
			  :router="true"
		      class="allServeMenu">
		      <el-menu-item index="http://gr.ddzzii.com">
		        <i class="el-icon-menu"></i>
		        <span slot="title">共享工人</span>
		      </el-menu-item>
		      <el-menu-item index="/">
		        <i class="el-icon-menu"></i>
		        <span slot="title">共享仓储</span>
		      </el-menu-item>
		      <el-menu-item index="http://jbgs.ddzzii.com">
		        <i class="el-icon-menu"></i>
		        <span slot="title">揭榜挂帅</span>
		      </el-menu-item>
		    </el-menu>
	  </el-drawer>
      <div class="inner">
        <div class="aside">
          <div class="page-title">消息中心</div>
          <el-menu :router="true" :default-active="menuActive" background-color="#EAEDF1">
            <el-menu-item index="/wholemessage">全部消息</el-menu-item>
            <el-menu-item index="/basic_info">未读消息</el-menu-item>
            <el-menu-item index="/authc">已读消息</el-menu-item>
          </el-menu>
        </div>
        <div class="main">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MessageLayout',
    data() {
      return {
		drawer: false,
		direction: 'ltr',
        menuActive: 'secure',
		circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      }
    },
    watch:{
      $route(to, from){
        this.updateActive()
      }
    },
    methods: {
      /**
       * 更新菜单激活项
       */
      updateActive(){
        let paths = this.$route.path.split('/')
        if (paths.length >= 2) {
          this.menuActive = '/' + paths[1]
        }
      },
	  logout () {
		  this.$api.user.logout().then(res => {
		  	console.log(res)
			if (res.code == 0){
				location.reload()
			}
		  })
	  }
    },
    created() {
      this.updateActive()
    },
  }
</script>

<style>
	.allServeMenu .el-menu-item:hover i{
		color: #F4D35C;
	}
	.root .el-drawer__wrapper{
		position: absolute;
	}
	.allServeMenu {
	}
	.userIconPopper{
		  padding: 0;
	}
</style>

<style scoped>
  .header {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    position: fixed;
    top: 0px;
    right: 0px;
    left: 0px;
    z-index: 9999;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px 0px;
    background-color: rgb(255, 255, 255);
    height: 60px;
  }
  .zWfDK{
	  display: flex;
	  -webkit-box-align: center;
	  align-items: center;
  }
  .iylSZi {
      width: 60px;
      height: 60px;
      line-height: 60px;
  }
  .gCXVCl {
      box-sizing: border-box;
      line-height: inherit;
      cursor: pointer;
      font-family: inherit;
      font-size: inherit;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      color: rgb(85, 85, 85);
      white-space: nowrap;
      padding: 0px;
      outline: medium;
      background: none rgb(255, 106, 0);
      text-decoration: none;
      transition: all 0.3s ease-out 0s;
      border-width: initial;
      border-style: none;
      border-color: initial;
      border-image: initial;
      overflow: hidden;
  }
  .iOnyRd {
      font-size: 20px;
	  color: #fff;
  }
  
  .DDlogo {
	  background-image: url(../../assets/icon/zzlogo.png);
	  display: block;
	  height: 32px;
	  width: 233px;
	  float: left;
	  margin: 14px 20px;
  }
  .DDlogoW{
	  float: left;
	  line-height: 48px;
	  font-size: 20px;
	  color: #F4D35C;
	  font-weight: 800;
  }
  .userIconNav{
	  float: left;
	  margin-right: 20px;
  }
  .userIconPopperTopNav{
	padding: 12px 12px 12px 12px;
	border-bottom: 1px solid #dedede;
  }
  .clearfix {
	  /* padding: 10px 10px 0 10px; */
  }
  .clearfix span{
	  font-size: 12px;
	  line-height: 36px;
  }
  .userIconPopperTopNav a{
  	  font-size: 14px;
	  color: #6c6c6c;
  }
  .userIconPopperTopUl{
  	  height: 22px;
	  margin: 0 3px;
  }
  .userIconPopperMediumNav li{
  	  padding-left: 10px;
  }
  .userIconPopperTopUl li:hover a{
	  color: #02b2f8;
  }
  .userIconPopperMediumNav {
	  padding:12px 0;
	  border-bottom: 1px solid #dedede;
  }
  .lkfbkL {
      box-sizing: border-box;
      cursor: pointer;
      font-family: inherit;
      font-size: inherit;
      vertical-align: middle;
      text-align: center;
      color: rgb(255, 106, 0);
      display: block;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 36px;
      line-height: 34px;
      outline: medium;
      background: none rgb(247, 247, 247);
      text-decoration: none;
      transition: all 0.3s ease-out 0s;
      border-width: 1px;
      border-style: solid;
      border-color: transparent;
      border-image: initial;
      overflow: hidden;
      padding: 0px 12px;
  }
  .root {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
  }
  .aside{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 180px;
    background-color: #EAEDF1;
  }
  .page-title{
    padding: 25px 15px;
    background-color: #D9DEE4;
    font-size: 16px;
    font-weight: bold;
  }
  .main{
    position: absolute;
    top: 0;
    right: 0;
    left: 180px;
    bottom: 0;
    padding: 15px;
    overflow: auto;
  }
</style>
<style>
  .message-layout .el-menu-item.is-active{
    background-color: #fff!important;
  }
  .message-layout .aside .el-menu{
    border: none;
  }
  .message-page>.header{
    padding-top: 10px;
    height: 50px;
    border-bottom: 1px solid #ddd;
  }
  .message-page>.header>.title{
    border-left: 2px solid #3a8ee6;
    padding-left: 10px;
    font-size: 16px;
  }
</style>
